import React, { useState, useEffect } from 'react';
import { Layout } from 'antd';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useMediaQuery } from '../hooks/useMediaQuery';
import CustomFooter from '../components/CustomFooter';
import CustomNavbar from '../components/CustomNavbar';
import EventSidebar from '../components/sidebar/EventSidebar';

const { Content } = Layout;

const EventDashboardLayout = () => {
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [collapsed, setCollapsed] = useState(isMobile);
  const isLoggedIn = JSON.parse(localStorage.getItem("logged_in"));

  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    }
  }, [location.pathname, isMobile]);

  return (
    isLoggedIn === true ? 
      <Layout style={{ minHeight: '100vh' }}>
        <EventSidebar
          trigger={null}
          collapsible={true}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />
        <Layout
          style={{
            marginLeft: collapsed ? 0 : 250, 
            transition: 'margin-left 0.2s',
            minHeight: '100vh',
          }}
        >
          <CustomNavbar collapsed={collapsed} setCollapsed={setCollapsed} />
          <Content style={{ margin: '24px 16px 0', overflow: 'auto' }}>
            <div
              style={{
                padding: 24,
                minHeight: 360,
                background: '#fff',
                borderRadius: '8px',
              }}
            >
              <Outlet />
            </div>
          </Content>
          <CustomFooter />
        </Layout>
      </Layout> : <Navigate to="/" />
  );
};

export default EventDashboardLayout;

